module.exports = __webpack_public_path__ + "img/3.df372011.jpeg";